import React from "react";
import { Segment, Header } from "semantic-ui-react";
import { Field } from "redux-form";

function renderOpciones(precios = {}) {
  const claves = Object.keys(precios);
  const valores = Object.values(precios);

  return (
    <React.Fragment>
      {claves.map((clave, index) => {
        const opciones = valores[index];

        const subclaves = Object.keys(valores[index]);
        const subvalores = Object.values(valores[index]);

        const comedor = clave.startsWith("sc")
          ? "Sin Comedor "
          : "Con Comedor ";

        return [
          <Header key={clave} as="h4">{`${comedor} ${opciones.nombre} de  ${
            opciones.horario
          }`}</Header>,
          subclaves.map(
            (subclave, ix) =>
              subclave !== "nombre" &&
              subclave !== "horario" &&
              subclave !== "key" ? (
                <div key={`${clave}_${subclave}`}>
                  <label>
                    <Field
                      id={`id_${clave}_${subclave}`}
                      name="servicios"
                      type="radio"
                      value={`${clave}_${subclave}_${subvalores[ix].nombre}_${
                        subvalores[ix].precio
                      }`}
                      component="input"
                    />
                    {` ${subvalores[ix].nombre} - ${subvalores[ix].precio} €`}
                  </label>
                </div>
              ) : null
          )
        ];
      })}
    </React.Fragment>
  );
}

function Servicios(props) {
  return (
    <Segment>
      <Header as="h3">Servicio que contrata</Header>
      {renderOpciones(props.precios)}
    </Segment>
  );
}

export default Servicios;



// WEBPACK FOOTER //
// ./src/pages/inscripcionesConfirmadas/inscripcionConfirmada/formularioInscripcion/Servicios.jsx